module.exports = __webpack_public_path__ + "img/foody.3acd5377.png";